import { PuzzlePiece, Truck, Recycle, ClipboardText, ListChecks, ChartBar, Wrench, Package, MapPin, Calculator, Camera, Buildings } from "@phosphor-icons/react";

// Mirrors backend bespoke_modules.ICONS
export const BESPOKE_ICONS = { PuzzlePiece, Truck, Recycle, ClipboardText, ListChecks, ChartBar, Wrench, Package, MapPin, Calculator, Camera, Buildings };

export const bespokeIcon = (name) => BESPOKE_ICONS[name] || PuzzlePiece;

export const money = (n) => `£${Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
export const monthLabel = (ym) => (ym ? new Date(`${ym}-01T00:00:00`).toLocaleDateString("en-GB", { month: "long", year: "numeric" }) : "—");
export const thisMonth = () => new Date().toISOString().slice(0, 7);

export const MODULE_STATUS = {
  draft: { label: "Being built", cls: "bg-amber-100 text-amber-800 dark:bg-amber-400/20 dark:text-amber-100" },
  live: { label: "Live", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-400/20 dark:text-emerald-100" },
  retired: { label: "Retired", cls: "bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-100" },
};

export const CHARGE_STATUS = {
  due: { label: "Due", cls: "bg-amber-100 text-amber-800 dark:bg-amber-400/20 dark:text-amber-100" },
  paid: { label: "Paid", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-400/20 dark:text-emerald-100" },
  waived: { label: "Waived", cls: "bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-100" },
};

export const REQUEST_STATUS = {
  new: { label: "New", cls: "bg-sky-100 text-sky-800 dark:bg-sky-400/20 dark:text-sky-100" },
  quoted: { label: "Quoted", cls: "bg-violet-100 text-violet-800 dark:bg-violet-400/20 dark:text-violet-100" },
  building: { label: "Building", cls: "bg-amber-100 text-amber-800 dark:bg-amber-400/20 dark:text-amber-100" },
  live: { label: "Live", cls: "bg-emerald-100 text-emerald-800 dark:bg-emerald-400/20 dark:text-emerald-100" },
  declined: { label: "Declined", cls: "bg-zinc-200 text-zinc-700 dark:bg-zinc-700 dark:text-zinc-100" },
};
export const REQUEST_ORDER = ["new", "quoted", "building", "live", "declined"];

export const ROLE_LABELS = { super_admin: "Owner / super admin", admin: "Admin", project_manager: "Project manager", team_member: "Team member", in_house: "Field crew / engineer (My Work)", hs_manager: "H&S manager", hr_manager: "HR manager", stakeholder: "Stakeholder" };
